import { type FC, useMemo } from 'react';

export interface CircularPerformanceIndicatorProps {
  label: string;
  color?: string;
  value: number;
}

export const CircularPerformanceIndicator: FC<
  CircularPerformanceIndicatorProps
> = (props) => {
  const formatNumber = useMemo(() => {
    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0,
    }).format;
  }, []);

  const radius = 38;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.max(0, Math.min(props.value, 100));

  return (
    <div className="relative inline-flex size-[88px] shrink-0">
      <svg
        viewBox="0 0 88 88"
        className="size-full -rotate-90"
        role="img"
        aria-label={`${props.label}: ${formatNumber(props.value)}`}
      >
        <circle
          cx="44"
          cy="44"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          className="text-muted"
        />
        <circle
          cx="44"
          cy="44"
          r={radius}
          fill="none"
          stroke={props.color ?? 'var(--primary)'}
          strokeWidth="7"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress / 100)}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-lg font-bold leading-tight">
          {formatNumber(props.value)}
        </span>
        <span className="text-xs font-light">{props.label}</span>
      </div>
    </div>
  );
};
